import {
  getGetOrganizationA2pSiteAddressQueryKey,
  getGetOrganizationBillingSubscriptionQueryKey,
  getGetOrganizationBillingUsageQueryKey,
  getGetOrganizationCalendarSettingsQueryKey,
  getGetOrganizationCheckInSettingsPosterLinksQueryKey,
  getGetOrganizationCheckInSettingsQueryKey,
  getGetOrganizationCancellationSettingsQueryKey,
  getGetOrganizationGiftCardArtworkQueryKey,
  getGetOrganizationKioskDevicesQueryKey,
  getGetOrganizationSettingsQueryKey,
  getGetOrganizationSetupGuideQueryKey,
  getGetOrganizationSubdomainQueryKey,
} from './generated/organization/organization';

export function getOrganizationSettingsOrgQueryKey(orgId: string) {
  return [...getGetOrganizationSettingsQueryKey(), orgId] as const;
}

export function getOrganizationCancellationSettingsOrgQueryKey(orgId: string) {
  return [...getGetOrganizationCancellationSettingsQueryKey(), orgId] as const;
}

export function getOrganizationGiftCardArtworkOrgQueryKey(orgId: string) {
  return [...getGetOrganizationGiftCardArtworkQueryKey(), orgId] as const;
}

export function getOrganizationCalendarSettingsOrgQueryKey(orgId: string) {
  return [...getGetOrganizationCalendarSettingsQueryKey(), orgId] as const;
}

export function getCheckInSettingsOrgQueryKey(orgId: string) {
  return [...getGetOrganizationCheckInSettingsQueryKey(), orgId] as const;
}

export function getKioskDevicesOrgQueryKey(orgId: string) {
  return [...getGetOrganizationKioskDevicesQueryKey(), orgId] as const;
}

export function getCheckInPosterLinksOrgQueryKey(orgId: string) {
  return [...getGetOrganizationCheckInSettingsPosterLinksQueryKey(), orgId] as const;
}

export function getOrganizationSetupGuideOrgQueryKey(orgId: string) {
  return [...getGetOrganizationSetupGuideQueryKey(), orgId] as const;
}

export function getOrganizationBillingUsageOrgQueryKey(orgId: string) {
  return [...getGetOrganizationBillingUsageQueryKey(), orgId] as const;
}

export function getOrganizationBillingSubscriptionOrgQueryKey(orgId: string) {
  return [...getGetOrganizationBillingSubscriptionQueryKey(), orgId] as const;
}

/** The salon's Bio Page web address as Business Details reads it (keyed by the route's short code). */
export function getOrganizationSubdomainOrgQueryKey(orgId: string) {
  return [...getGetOrganizationSubdomainQueryKey(), orgId] as const;
}

/** The texting-compliance website address (`{label}.{apex of its site type}`) on Business Details. */
export function getA2pSiteAddressOrgQueryKey(orgId: string) {
  return [...getGetOrganizationA2pSiteAddressQueryKey(), orgId] as const;
}
